<header
  #header
  class="modal-header mbs-modal_header">
  <div class="form-row">
    <div class="col overflow-hidden">
      @if (wizardTitle) {
        <ng-template [ngTemplateOutlet]="wizardTitle.template" />
      } @else {
        <h5 class="modal-title mbs-modal_title text-overflow">
          {{ title }}
        </h5>
      }
    </div>
    @if (!hideCrossButton) {
      <div class="col-auto">
        <mbs-button
          [icon]="'ico ico-Close'"
          [isCtrl]="true"
          [type]="'dark'"
          (click)="closeWithConfirm('Cross click')" />
      </div>
    }
  </div>
</header>

<div
  class="modal-body mbs-wizard_body"
  [style.height]="sanitizedHeight || defaultWizardHeight"
  [style.min-height]="sanitizedMinHeight || sanitizedHeight"
  [class.overflow-hidden]="scrollableStepContent">
  @if (initialLoading) {
    <mbs-loader />
  } @else {
    <div class="row g-0 h-100">
      @if (stepsOrientation === 'vertical' && showSteps) {
        <div
          class="col-3"
          [class.h-100]="scrollableStepContent">
          <ul
            class="nav nav-tabs flex-column h-100"
            [class.overflow-y-auto]="scrollableStepContent"
            [class.overflow-x-hidden]="scrollableStepContent"
            [class.wizard_v_tabs_scroll]="scrollableStepContent">
            @for (step of steps; track step?.title ?? step) {
              <li class="nav-item">
                <button
                  class="nav-link mbs-wizard_nav-tabs"
                  [attr.data-e2e]="step.e2eLocator"
                  [disabled]="!step.completed && !step.canOpen && !isOpenSteps"
                  [ngClass]="stepClasses(step)"
                  (click)="selectManualStep($any($event), step)">
                  <span class="nav-item_index">{{ $index + 1 }}</span>
                  <span class="nav-item_text">{{ step.title }}</span>
                  @for (markedStep of stepMarks.$markedSteps | async; track markedStep) {
                    <span [class]="step.title === markedStep ? 'nav-item_alert ico ico-error text-danger' : ''"></span>
                  }
                </button>
              </li>
            }
          </ul>
        </div>
      }

      <div
        [class.h-100]="scrollableStepContent"
        [class.position-relative]="loading"
        [ngClass]="stepContainerClasses()">
        <ng-content
          ngProjectAs="[prependStep]"
          select="[prependStep]" />
        <div
          class="mbs-wizard-steps_container position-relative"
          [class.overflow-auto]="scrollableStepContent"
          (scroll)="handleStepScroll()">
          @if (stepsOrientation === 'horizontal' && showSteps) {
            <ul class="mbs-wizard-steps">
              @for (step of steps; track step?.title ?? step) {
                <li
                  class="mbs-wizard-steps_item col-auto"
                  [ngClass]="stepClasses(step)"
                  (click)="step.completed ? selectManualStep($any($event), step) : ''">
                  <div class="mbs-wizard-steps_link">{{ step.title }}</div>
                </li>
              }
            </ul>
          }
          @if (loading) {
            <mbs-loader />
          } @else {
            <ng-content />
          }
        </div>
      </div>
    </div>
  }
</div>

@if (showFooter) {
  <footer
    #footer
    class="modal-footer mbs-modal_footer">
    @if (currentStep?.documentationLink) {
      <div class="mr-auto">
        <a
          target="_blank"
          [href]="currentStep?.documentationLink">
          <span class="ico ico-question-circle"></span>
          <span class="ml-2">Help documentation</span>
        </a>
      </div>
    }

    @if (prepend && !prepend.hide) {
      <div class="mr-auto">
        <ng-container [ngTemplateOutlet]="prepend.template" />
      </div>
    }

    @if (!hideNextAndBackButtons) {
      <mbs-group-button
        class="mr-3"
        [type]="nextAndBackButtonType">
        @if (!backButton.hide) {
          <mbs-button
            [attr.data-e2e]="backButton.e2eLocator"
            [disabled]="backButton.loading || backButton.disabled || (buttonLoadingMode && loading) || steps?.first === currentStep"
            [id]="'back_' + currentStep?.title?.replaceAll(' ', '_')"
            [loading]="(buttonLoadingMode && loading) || backButton.loading"
            [size]="backButton.size"
            [type]="nextAndBackButtonType"
            (click)="backButtonClicked()">
            @if (backButton.icon; as icon) {
              <span [ngClass]="[icon]"></span>
            }
            {{ backButton.text }}
          </mbs-button>
        }

        @if (!nextButton.hide) {
          <mbs-button
            [attr.data-e2e]="nextButton.e2eLocator"
            [disabled]="nextButton.loading || nextButton.disabled || (buttonLoadingMode && loading) || steps?.last === currentStep"
            [id]="'next_' + currentStep?.title?.replaceAll(' ', '_')"
            [loading]="(buttonLoadingMode && loading) || nextButton.loading"
            [size]="nextButton.size"
            [type]="nextAndBackButtonType"
            (click)="nextButtonClicked()">
            @if (nextButton.icon; as icon) {
              <span [ngClass]="[icon]"></span>
            }
            {{ nextButton.text }}
          </mbs-button>
        }
      </mbs-group-button>
    }

    @if (!saveButton.hide && !saveButtonGroup?.length) {
      <mbs-button
        [attr.data-e2e]="saveButton.e2eLocator"
        [disabled]="saveButtonDisabled"
        [id]="'save_' + currentStep?.title?.replaceAll(' ', '_')"
        [loading]="(!disableSpinner && spinnerShow) || (buttonLoadingMode && loading) || saveButton.loading"
        [ngbTooltip]="saveButtonTooltip"
        [placement]="'top auto'"
        [size]="saveButton.size"
        [tooltipClass]="'tooltip-lg'"
        [triggers]="'hover focus'"
        [type]="saveButton.type ? saveButton.type : 'success'"
        (click)="saveButtonClicked()">
        @if (saveButton.icon; as icon) {
          <span [ngClass]="[icon]"></span>
        }

        {{ saveButton.text }}
      </mbs-button>
    }

    @for (saveButtonGroupItem of saveButtonGroup || []; track saveButtonGroupItem?.id ?? saveButtonGroupItem) {
      <mbs-button
        [disabled]="
          saveButtonGroupItem.disabled ||
          saveButtonGroupItem.loading ||
          (!disableSpinner && spinnerShow) ||
          (buttonLoadingMode && loading) ||
          (!isOpenSteps && steps?.last !== currentStep && !disableSpinner)
        "
        [id]="saveButtonGroupItem.text + '_' + currentStep?.title?.replaceAll(' ', '_')"
        [loading]="(!disableSpinner && spinnerShow) || (buttonLoadingMode && loading) || saveButtonGroupItem.loading"
        [size]="saveButtonGroupItem.size"
        [type]="saveButtonGroupItem.type ? saveButtonGroupItem.type : 'success'"
        (click)="handleSave(saveButtonGroupItem.action)">
        @if (saveButtonGroupItem.icon; as icon) {
          <span [ngClass]="[icon]"></span>
        }

        {{ saveButtonGroupItem.text }}
      </mbs-button>
    }

    @if (!cancelButton.hide) {
      <mbs-button
        [disabled]="cancelButton.loading || cancelButton.disabled || (!disableSpinner && spinnerShow) || (buttonLoadingMode && loading)"
        [id]="'close_' + currentStep?.title?.replaceAll(' ', '_')"
        [loading]="(!disableSpinner && spinnerShow) || (buttonLoadingMode && loading) || cancelButton.loading"
        [size]="cancelButton.size"
        [type]="cancelButton.type ? cancelButton.type : 'secondary'"
        (click)="handleClose()">
        @if (cancelButton.icon; as icon) {
          <span [ngClass]="[icon]"></span>
        }
        {{ cancelButton.text }}
      </mbs-button>
    }
  </footer>
}

@if (cover) {
  <mbs-loader
    [text]="cover"
    [useFixedDocumentSpinner]="true"
    [useFixedSize]="true" />
}
